export enum TerritoryDrawMode {
  FREE_DRAW,
  GEOGRAPHY,
}
export enum GeographyType {
  DRIVE_TIME,
  RING,
}
export enum GeographyTypeMeasurement {
  MILE,
  KILOMETER,
}
export enum GeographyBorderThickness {
  XTHIN,
  THIN,
  MEDIUM,
  THICK,
}
export enum PrintFileTypeOutput {
  PNG,
  PDF,
}
export enum PrintLegend {
  ON,
  OFF,
}
export enum MatchView {
  GRID,
  LIST,
}
export enum MatchArea {
  CONTACTS,
  MY_ACTIVITY,
  FILES,
}
export enum CollaborateOptions {
  ALL,
  LOCATION_FILTERS,
  TERRITORIES,
  PUSHPINS,
  AOI_THEMATICS,
  VIEW_REPORTS,
  REPORT_HISTORY,
  CONTACT_ACTIVITY,
  CONTACTS,
  PROSPECTS,
}
export enum ColorOptions {
  AUTO,
  CUSTOM,
}

export enum UserSettingsMenuSelection {
  USER_PROFILE,
  ACCOUNT_TEAM,
  USER_PREFERENCES,
  USER_MANAGEMENT,
  TERRITORY_MANAGEMENT,
  ACCOUNT_INFORMATION,
  COMPANY_MANAGEMENT,
  TIMEOUT_MANAGEMENT,
}
